/** Error code the backend sends when the coach closed an area to the team's players (VOL-181). */
export const PLAYER_ACCESS_DENIED = 'PLAYER_ACCESS_DENIED';

/**
 * Structural check on purpose: importing `HttpError` from `@/services/http` here would
 * create an import cycle through the auth controller and the query client.
 */
export function isPlayerAccessDenied(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false;
  if (!('status' in error) || error.status !== 403) return false;
  if (!('body' in error) || typeof error.body !== 'object' || error.body === null) return false;
  return 'code' in error.body && error.body.code === PLAYER_ACCESS_DENIED;
}

export type PlayerAccessDeniedArea = 'stats' | 'video';

/** Which access the coach closed, when the server names it (absent for the live room). */
export function playerAccessDeniedArea(error: unknown): PlayerAccessDeniedArea | null {
  if (!isPlayerAccessDenied(error)) return null;
  const body = (error as { body: object }).body;
  const area = 'area' in body ? body.area : undefined;
  return area === 'stats' || area === 'video' ? area : null;
}
